import { IQuestionRequest } from './../model/question.model';
import { catchError } from 'rxjs/operators';
import { EnvService } from './../../services/env.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { IQuestionResponse } from '../model/question.model';
import { JsonPipe } from '@angular/common';


@Injectable()
export class SecurityQuestionsService {

  constructor(private http: HttpClient, private env:EnvService){ }  
  getSecurityQuestions( questionRequest :IQuestionRequest):Observable<IQuestionResponse>  {

    const baseUrl = this.env.apiBaseUrls
    
    let url =`${baseUrl}/account/security_questions/all`
    
    //return this.http.post<IQuestionResponse>(url,request)
    return this.http.post<IQuestionResponse>(url,questionRequest)
            .pipe(catchError(this.handleError<IQuestionResponse>('getSecurityQuestions')))

  }
  getUserSecurityQuestions( questionRequest :IQuestionRequest):any  {

  // getUserSecurityQuestions( questionRequest :IQuestionRequest):Observable<IQuestionResponse>  {
    const baseUrl = this.env.apiBaseUrls

    let url =`${baseUrl}/account/security_questions/user_noA`
    let headers = new HttpHeaders({
      'Content-type':'application/json',
    })

    let options = {headers: headers}

    return this.http.post<IQuestionResponse>(url,questionRequest, options)
          .pipe(catchError(this.handleError<IQuestionResponse>('getUserSecurityQuestions')))
  }
  private handleError<T> (operation ='operation', result?:T){
    return (error: any): Observable<T> => {
      console.error(error)
      return of(result as T)
    }
  }

}


